import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class ModuleService {
    // Get all 
    static async getAllModules(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.MODULES}`; // endpoint
        const requestModel = { storeId };
        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch modules.');
            return [];
        }
    }

    // Create 
    static async addNewModule(data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.MODULES}`; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Module added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new module.');
        }
    }

    // Get by ID
    static async getModuleById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.MODULES}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch module by ID');
        }
    }

    // Update 
    static async updateModuleById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.MODULES}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Module updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update module.');
        }
    }

    // Delete by ID
    static async deleteModule(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.MODULES}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete module.');
            }
        } catch (error) {
            console.error('Error deleting module:', error);
            throw error;
        }
    }

    // Delete multiple 
    static async deleteManyModules(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.MODULES}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
